import RadioGroup from '../radio/src/radio-group.vue'

export default RadioGroup
